import React, { ReactElement } from 'react';
import { NavigationButtons } from '../../shared/NavigationButtons';
import { Form, Formik } from 'formik';
import { CoverageCheckupState, goToNextStep, updateCoverageCheckupState } from '../../../store/step';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { InsuranceDetailsForm } from '../../shared/InsuranceDetailsForm';
import { createInsuranceDetailsSchema } from '../../schema/InsuranceDetailsSchema';
import { CardPadding, GrayCard, GrayCardHeader } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function CreditReportStep(): ReactElement {
  const dispatch = useDispatch();
  const { creditReportLastReviewed: creditReportLastReviewed } = useSelector(
    (state: RootState) => state.steps
  );

  const formRef = useFormInteractionTracking('last_checked_credit_report');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }
  return (
    <>
      <GrayCard>
        <GrayCardHeader
          header="Credit Report"
          subHeader="Credit reporting companies collect information about you, including your
          personal info, credit (debt) history, public records, and inquiries into
          your credit. Your credit report is different from your credit score."
        />
      </GrayCard>

      <CardPadding>
        <CardHeader header="When was the last time you looked over your credit report?" />
        <Formik
          initialValues={{ creditReportLastReviewed }}
          onSubmit={onSubmit}
          validationSchema={createInsuranceDetailsSchema(
            'creditReportLastReviewed'
          )}
        >
          <Form ref={formRef}>
            <InsuranceDetailsForm name="creditReportLastReviewed" />
            <NavigationButtons />
          </Form>
        </Formik>
      </CardPadding>
    </>
  );
}

export { CreditReportStep };
